import _ from 'lodash';

const HelperGraphql = {

	createFields: ( fields ) => {
		const list = [];
		
		_.forEach( fields, ( value, key ) => {
			list.push( `$${key}: ${value}` );
		})
		
		return list.join(', ');
	},
	
	createVariables: ( fields ) => {
		const list = [];
		
		_.forEach( fields, ( value, key ) => {
			list.push( `${key}: $${key}` );
		});
		
		return list.join(', ');
	}
}

export default HelperGraphql
